// import ContentData from '../content.json'

const ContentData = [
  {
    "id": 1,
    "header": "Infopunkt 1",
    "text": "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
  },
  {
    "id": 2,
    "header": "Infopunkt 2",
    "text": "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
  },
  {
    "id": 3,
    "header": "Infopunkt 3",
    "text": "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
  }
]

export type Content = {
  id: number,
  header: string,
  text: string
}

export abstract class ContentManager {

  public static GetContentById(id: number) {
    return ContentData.find(content => content.id === id)
  }

}